import { withStatusOrder } from './utils';

export const OPTUBL01 = {
    header: {
        en: 'Chat Initiated',
        hi: 'चैट शुरू हुई',
        kn: 'ಚಾಟ್ ಆರಂಭವಾಗಿದೆ',
        ta: 'அரட்டை தொடங்கப்பட்டது',
        te: 'చాట్ ప్రారంభించబడింది',
    },
    label: {
        en: 'Enquiry Creation Pending',
        hi: 'जांच निर्माण लंबित',
        kn: 'ವಿಚಾರಣೆ ರಚನೆ ಬಾಕಿಯಾಗಿದೆ',
        ta: 'விசாரணை உருவாக்கம் நிலுவையில் உள்ளது',
        te: 'విచారణ సృష్టి పెండింగ్‌లో ఉంది',
    },
    order: 1,
    color: 'info',
    description: {
        en: 'The customer has received the WhatsApp flow. Awaiting flow submission.',
        hi: 'ग्राहक को व्हाट्सएप फ्लो प्राप्त हुआ है। प्रवाह सबमिशन की प्रतीक्षा है।',
        kn: 'ಗ್ರಾಹಕ ವಾಟ್ಸಾಪ್ ಪ್ರವಾಹವನ್ನು ಪಡೆದಿದ್ದಾರೆ. ಪ್ರಕ್ರಿಯೆ ಸಲ್ಲಿಕೆಗೆ ಕಾಯಲಾಗುತ್ತಿದೆ.',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் ஓட்டை பெற்றுள்ளார். ஓட்டத்தை சமர்ப்பிக்க காத்திருக்கிறார்.',
        te: 'కస్టమర్ వాట్సాప్ ఫ్లో పొందాడు. ఫ్లో సమర్పణ కోసం వేచి ఉంది.',
    },
};

export const OPTUBL02 = {
    header: {
        en: 'Enquiry Created',
        hi: 'जांच बनाई गई',
        kn: 'ವಿಚಾರಣೆ ರಚಿಸಲಾಗಿದೆ',
        ta: 'விசாரணை உருவாக்கப்பட்டது',
        te: 'విచారణ రూపొందించబడింది',
    },
    label: {
        en: 'Digio KYC Pending',
        hi: 'डिजियो केवाईसी लंबित',
        kn: 'ಡಿಜಿಯೋ ಕೆವೈಸಿ ಬಾಕಿಯಾಗಿದೆ',
        ta: 'டிஜியோ கேஒய்சி நிலுவையில் உள்ளது',
        te: 'డిజియో కేవైసీ పెండింగ్‌లో ఉంది',
    },
    order: 2,
    color: 'info',
    description: {
        en: 'The customer has received the WhatsApp flow. Awaiting flow submission.',
        hi: 'ग्राहक को व्हाट्सएप फ्लो प्राप्त हुआ है। प्रवाह सबमिशन की प्रतीक्षा है।',
        kn: 'ಗ್ರಾಹಕ ವಾಟ್ಸಾಪ್ ಪ್ರವಾಹವನ್ನು ಪಡೆದಿದ್ದಾರೆ. ಪ್ರಕ್ರಿಯೆ ಸಲ್ಲಿಕೆಗೆ ಕಾಯಲಾಗುತ್ತಿದೆ.',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் ஓட்டை பெற்றுள்ளார். ஓட்டத்தை சமர்ப்பிக்க காத்திருக்கிறார்.',
        te: 'కస్టమర్ వాట్సాప్ ఫ్లో పొందాడు. ఫ్లో సమర్పణ కోసం వేచి ఉంది.',
    },
};

export const OPTUBL12 = {
    header: {
        en: 'Digio KYC',
        hi: 'डिजियो केवाईसी',
        kn: 'ಡಿಜಿಯೋ ಕೆವೈಸಿ',
        ta: 'டிஜியோ கேஒய்சி',
        te: 'డిజియో కేవైసీ',
    },
    label: {
        en: 'Account Aggregator Pending',
        hi: 'खाता एग्रीगेटर लंबित',
        kn: 'ಖಾತೆ ಅಗ್ರಿಗೇಟರ್ ಬಾಕಿಯಾಗಿದೆ',
        ta: 'கணக்கு திரட்டி நிலுவையில் உள்ளது',
        te: 'ఖాతా అగ్రిగేటర్ పెండింగ్‌లో ఉంది',
    },
    order: 3,
    color: 'info',
    description: {
        en: 'The customer has verified their KYC.',
        hi: 'ग्राहक ने अपना केवाईसी सत्यापित किया है।',
        kn: 'ಗ್ರಾಹಕ ತಮ್ಮ ಕೆವೈಸಿ ಅನ್ನು ದೃಢೀಕರಿಸಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் தனது கேஒய்சியை சரிபார்த்துள்ளார்.',
        te: 'కస్టమర్ తన కేవైసీని ధృవీకరించాడు.',
    },
};

export const OPTUBL11 = {
    header: {
        en: 'Account Aggregator',
        hi: 'खाता एग्रीगेटर',
        kn: 'ಖಾತೆ ಅಗ್ರಿಗೇಟರ್',
        ta: 'கணக்கு திரட்டி',
        te: 'ఖాతా అగ్రిగేటర్',
    },
    label: {
        en: 'Income Details Pending',
        hi: 'आय विवरण लंबित',
        kn: 'ಆದಾಯ ವಿವರ ಬಾಕಿಯಾಗಿದೆ',
        ta: 'வருமான விவரங்கள் நிலுவையில் உள்ளது',
        te: 'ఆదాయ వివరాలు పెండింగ్‌లో ఉన్నాయి',
    },
    order: 4,
    color: 'info',
    description: {
        en: 'Accounts linked.',
        hi: 'खाते जुड़ गए हैं।',
        kn: 'ಖಾತೆಗಳು ಲಿಂಕ್ ಆಗಿವೆ.',
        ta: 'கணக்குகள் இணைக்கப்பட்டுள்ளன.',
        te: 'ఖాతాలు లింక్ చేయబడ్డాయి.',
    },
};

export const OPTUBL03 = {
    header: {
        en: 'Income Details',
        hi: 'आय विवरण',
        kn: 'ಆದಾಯ ವಿವರಗಳು',
        ta: 'வருமான விவரங்கள்',
        te: 'ఆదాయ వివరాలు',
    },
    label: {
        en: 'Application Submission Pending',
        hi: 'आवेदन जमा करना लंबित',
        kn: 'ಅರ್ಜಿ ಸಲ್ಲಿಕೆ ಬಾಕಿಯಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்க நிலுவையில் உள்ளது',
        te: 'దరఖాస్తు సమర్పణ పెండింగ్‌లో ఉంది',
    },
    order: 5,
    color: 'info',
    description: {
        en: 'The customer has filled the income and expense details in the application form.',
        hi: 'ग्राहक ने आवेदन पत्र में आय और व्यय का विवरण भरा है।',
        kn: 'ಗ್ರಾಹಕ ಅರ್ಜಿ ನಮೂನೆಯಲ್ಲಿ ಆದಾಯ ಮತ್ತು ವೆಚ್ಚದ ವಿವರಗಳನ್ನು ತುಂಬಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் விண்ணப்பப் படிவத்தில் வருமான மற்றும் செலவு விவரங்களை நிரப்பியுள்ளார்.',
        te: 'కస్టమర్ దరఖాస్తు ఫారమ్‌లో ఆదాయం మరియు ఖర్చుల వివరాలను పూరించాడు.',
    },
};

export const OPTUBL08 = {
    header: {
        en: 'Application Submitted',
        hi: 'आवेदन जमा किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'దరఖాస్తు సమర్పించబడింది',
    },
    label: {
        en: 'Awaiting Decision',
        hi: 'निर्णय की प्रतीक्षा',
        kn: 'ನಿರ್ಣಯಕ್ಕಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
        ta: 'முடிவுக்காக காத்திருக்கிறது',
        te: 'తీర్మానం కోసం వేచి ఉంది',
    },
    order: 6,
    color: 'success',
    description: {
        en: 'The customer has submitted their application.',
        hi: 'ग्राहक ने अपना आवेदन जमा किया है।',
        kn: 'ಗ್ರಾಹಕ ತಮ್ಮ ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಿದ್ದಾರೆ.',
        ta: 'வாடிக்கையாளர் தனது விண்ணப்பத்தை சமர்ப்பித்துள்ளார்.',
        te: 'కస్టమర్ తన దరఖాస్తును సమర్పించాడు.',
    },
};

export const OPTUBL09 = {
    header: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் மறுக்கப்பட்டது',
        te: 'దరఖాస్తు తిరస్కరించబడింది',
    },
    label: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் மறுக்கப்பட்டது',
        te: 'దరఖాస్తు తిరస్కరించబడింది',
    },
    order: 7,
    color: 'error',
    description: {
        en: 'The loan application has been rejected.',
        hi: 'ऋण आवेदन अस्वीकृत हो गया है।',
        kn: 'ಸಾಲದ ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ.',
        ta: 'கடன் விண்ணப்பம் மறுக்கப்பட்டது.',
        te: 'రుణ దరఖాస్తు తిరస్కరించబడింది.',
    },
};

export const UBLActiveCases = withStatusOrder({
    OPTUBL01,
    OPTUBL02,
    OPTUBL12,
    OPTUBL11,
    OPTUBL03,
});

export const UBLContinueJourneyCases = withStatusOrder({
    OPTUBL02,
    OPTUBL12,
    OPTUBL11,
    OPTUBL03,
});

export const UBLSanction = withStatusOrder({
    OPTUBL08,
});

export const UBLRejected = withStatusOrder({
    OPTUBL01,
    OPTUBL02,
    OPTUBL12,
    OPTUBL11,
    OPTUBL03,
    // OPTUBL09,
});

export const UBLCancelled = withStatusOrder({
    OPTUBL01,
    OPTUBL02,
    OPTUBL12,
    OPTUBL11,
    OPTUBL03,
    OPTUBL08,
})

const OPTUBL02_Unserviceable = {
    ...OPTUBL02,
    header: {
        ...OPTUBL02.header,
        en: 'Unserviceable',
    }
}

export const UBLUnserviceable = withStatusOrder({
    OPTUBL02: OPTUBL02_Unserviceable,
})

export const getUBLAll = (currentStatusCode) => {
    let UBLAll = {
        OPTUBL01,
        OPTUBL02,
        OPTUBL12,
        OPTUBL11,
        OPTUBL03,
        OPTUBL08,
    };

    if (currentStatusCode === 'OPTUBL09') {
        UBLAll = {
            ...UBLAll,
            OPTUBL09,
        }
    } else {
        UBLAll = {
            ...UBLAll,
            OPTUBLXX: {
                header: {
                    en: 'Awaiting Decision',
                    hi: 'फैसले का इंतजार',
                    kn: 'ತೀರ್ಮಾನಕ್ಕಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
                    ta: 'முடிவிற்காக காத்திருக்கிறது',
                    te: 'నిర్ణయం కోసం వేచి ఉంది',
                },
                color: 'success',
            },
        }
    }

    return withStatusOrder(UBLAll);
};